import React, {useEffect, useState} from 'react';
import {Loading, MapReport} from "../components";
import {Box, Container} from '@mui/material'
import Api from "../utils/api";
import FusionCharts from "fusioncharts";
import ReactFC from "react-fusioncharts";
// Step 4 - Include the chart type
import mscombi2d  from 'fusioncharts/fusioncharts.charts';
import moment from 'moment-jalaali'
// Step 5 - Include the theme as fusion
import FusionTheme from 'fusioncharts/themes/fusioncharts.theme.fusion';
import {CircularProgress} from "@mui/material";
import {authRefresh} from "../actions";
import {useDispatch, useSelector} from "react-redux";
ReactFC.fcRoot(FusionCharts, mscombi2d , FusionTheme);


export const Admin = () => {


    const [mapReport, setMapReport] = useState([]);
    const [totalMapReport, setTotalMapReport] = useState([]);
    const [chart, setChart] = useState({});
    const [loading, setLoading] = useState(true);
    const dispatch = useDispatch();
    const AppState = useSelector(state => state);
    useEffect(() => {

        if (moment().unix() > AppState.authReducer.expiration) {
            dispatch(authRefresh());
        }
    }, []);

    useEffect(() => {

        if (AppState.authReducer.login) {
            if (+AppState.authReducer.user.permissions.period?.get_sales_daily_report_admin?.access === 1 && +AppState.authReducer.user.permissions.period?.get_map_report_admin?.access === 1 ) {
                new Api().get('/period/sales-daily-report').then((response) => {
                    if (typeof response != "undefined") {

                        let chart = {
                            label: [],
                            total_pay: [],
                            total_count: [],
                            gateway_total_pay: [],
                            gateway_total_count: [],
                            voucher_total_pay: [],
                            voucher_total_count: [],
                            wallet_total_pay: [],
                            wallet_total_count: [],
                            return_total_pay: [],
                            return_total_count: [],

                        };

                        response.map((r, key) => {
                            chart.label.push({'label' : moment(r.label, 'YYYY/MM/DD HH:mm:ss').locale('fa').format('jM/jDD')});
                            chart.total_pay.push({'value' : r.total_pay});
                            chart.total_count.push({'value' : r.total_count});
                            chart.gateway_total_pay.push({'value' : r.gateway_total_pay});
                            chart.gateway_total_count.push({'value' : r.gateway_total_count});
                            chart.voucher_total_pay.push({'value' : r.voucher_total_pay});
                            chart.voucher_total_count.push({'value' : r.voucher_total_count});
                            chart.wallet_total_pay.push({'value' : r.wallet_total_pay});
                            chart.wallet_total_count.push({'value' : r.wallet_total_count});
                            chart.return_total_pay.push({'value' : r.return_total_pay});
                            chart.return_total_count.push({'value' : r.return_total_count});
                        });

                        setChart(chart);
                        setLoading(false);
                        if(!response.status) {
                            setLoading(false)
                        }
                    }
                })

                new Api().get('/period/mapReport').then((response) => {
                    if (typeof response !== "undefined") {
                        setMapReport(response);
                        if(!response.status) {
                            setLoading(false)
                        }
                    }
                })
                new Api().get('/reports/totalMapReport').then((response) => {
                    if (typeof response !== "undefined") {
                        setTotalMapReport(response);
                        if(!response.status) {
                            setLoading(false)
                        }
                    }
                })
            }



        }


    }, []);


    const chartConfigs = {
        type: 'mscombi2d',// The chart type
        width: '100%', // Width of the chart
        height: '400', // Height of the chart
        dataFormat: 'json', // Data type
        dataSource: {
            "chart": {
                "caption": "گزارش میزان فروش",
                "yAxisName": "مبلغ به تومان",
                "theme": "fusion",
                "formatNumberScale" : '0',
                "decimalSeparator": ".",
                "thousandSeparator": ",",
            },
            "categories": [
                {
                    "category": chart.label
                }
            ],
            "dataset": [
                {
                    "seriesName": "تعداد کل",
                    "renderAs": "line",
                    "data": chart.total_count
                },
                {
                    "seriesName": "مبلغ کل",
                    "renderAs": "line",
                    "data": chart.total_pay
                },
                {
                    "seriesName": "تعداد ورودی درگاه",
                    "renderAs": "line",
                    "data": chart.gateway_total_count
                },
                {
                    "seriesName": "ورودی درگاه",
                    "renderAs": "line",
                    "data": chart.gateway_total_pay
                },
                {
                    "seriesName": "تعداد بن کالا",
                    "renderAs": "line",
                    "data": chart.voucher_total_count
                },
                {
                    "seriesName": "مبلغ بن کالا",
                    "renderAs": "line",
                    "data": chart.voucher_total_pay
                },
                {
                    "seriesName": "تعداد کیف پول",
                    "renderAs": "line",
                    "data": chart.wallet_total_count
                },
                {
                    "seriesName": "مبلغ کیف پول",
                    "renderAs": "line",
                    "data": chart.wallet_total_pay
                },
                {
                    "seriesName": "تعداد مرجوعی",
                    "renderAs": "line",
                    "data": chart.return_total_count
                },
                {
                    "seriesName": "مبلغ مرجوعی",
                    "renderAs": "line",
                    "data": chart.return_total_pay
                },
            ]
        }
    };
    return(
        <Container>
            { +AppState.authReducer.user.permissions.period?.get_sales_daily_report_admin?.access === 1 && +AppState.authReducer.user.permissions.period?.get_map_report_admin?.access === 1 &&
            <React.Fragment>
                <Box style={{margin: '30px 0', minHeight: '400px'}}>
                    {loading ? <Loading/>:
                        <ReactFC {...chartConfigs}/>}
                </Box>
                {mapReport && <MapReport list={mapReport}/>}
            </React.Fragment>
            }
            {totalMapReport.length > 0 &&
            <React.Fragment>
                <h1>گزارش کلی</h1>
                <MapReport list={totalMapReport}/>
            </React.Fragment>
            }
        </Container>
    );
}

export default Admin;
